"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttleAsyncify = void 0;
const throttle_async_executor_1 = require("./throttle-async-executor");
function throttleAsyncify(originalMethod, parallelCalls = 1) {
    const executor = new throttle_async_executor_1.ThrottleAsyncExecutor(originalMethod, parallelCalls);
    return function (...args) {
        return executor.exec(this, args);
    };
}
exports.throttleAsyncify = throttleAsyncify;
